<template>
  <div id="sidebarmobile" class="sidebar_info">
    <keep-alive>
      <router-view class="mobile-map" name='map'></router-view>
    </keep-alive>
    <!--<router-view class="mobile-profile" name='profile'></router-view>-->
    <router-view class="mobile-search" name='race'></router-view>
    <router-view v-if="event.id == '220'" class="desktop-social" name='social'></router-view>
    <router-view class="mobile-search" name='search'></router-view>
    <router-view class="mobile-cat" name='categories'></router-view>
    <router-view class="mobile-leaderboard" name='leaderboard' style="overflow-y: scroll; flex: 1 1 0px;"></router-view>
    <router-view class="mobile-following" name="checkpoint"></router-view>
    <router-view class="mobile-following" name="athletedetailed"></router-view>
    <router-view class="mobile-following" name="following" style="overflow-y: scroll; flex: 1 1 0px;"></router-view>
    <router-view class="mobile-following" name="menu"></router-view>
    <!--<router-view class="mobile-following" name="bird"></router-view>-->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default{
  computed: {
    ...mapGetters({
      mobile: 'mobile',
      event: 'event'
    })
  }
}
</script>
<style>
  #sidebarmobile {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  #sidebarmobile > .mobile-map {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    order: 3;
  }

  #sidebarmobile > .mobile-leaderboard {
    flex: 1;
    display: flex;
    order: 3;
  }

  #sidebarmobile > .mobile-following {
    flex: 1;
    order: 3;
  }

  #sidebarmobile > .mobile-profile {
    flex: 0 0 144px;
    order: 4;
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebarm.vue